//== Start add burger-menu ==//
const burgerBtn = document.querySelector('.header__burger')
const html = document.querySelector('html')
const header = document.querySelector('.header')
const menuItems = document.querySelectorAll('.header__menu a')
const burgerMenu = document.querySelector('.header__main-burger')
const contactBtn = document.querySelector('.header__contact')

burgerBtn.addEventListener('click', () => {
    header.classList.toggle('open')
    burgerMenu.classList.toggle('open')
    burgerBtn.classList.toggle('open')

    if (burgerMenu.classList.contains('open')) {
        changeHtmlOverflow('add')
    } else {
        changeHtmlOverflow('remove')
    }
})

const changeHtmlOverflow = (action) => {
    if (action === 'add') {
        html.style.overflow = 'hidden'
    }
    if (action === 'remove') {
        html.style.overflow = 'inherit'
    }
}
//== End add burger-menu ==//

window.addEventListener('scroll', () => {
    const scrollPosition = window.scrollY;

    if (scrollPosition > 50) {
        header.classList.add('scrolled');
    } else {
        header.classList.remove('scrolled');
    }
});

const current = document.querySelector(".header__current");
const select = document.querySelector(".header__select");
current && current.addEventListener("click", () => {
    select.classList.toggle("active");
    current.classList.toggle("active");
});

// document.addEventListener("click", (e) => {
//   if (!e.composedPath().includes(select) && !e.composedPath().includes(current)) {
//     select.classList.remove("active");
//     current.classList.remove("active");
//   }
// })

document.addEventListener('DOMContentLoaded', function() {
    const memberSingle = document.body.classList.contains('single-members')
    const newsPage = document.body.classList.contains('page-template-news-template')
    const newsPost = document.body.classList.contains('single-post')
    if (memberSingle || newsPage|| newsPost) {
      header.classList.add('scrolled');
      window.addEventListener('scroll', () => {
        const scrollPosition = window.scrollY;
        if (scrollPosition > 0) {
            header.classList.add('scrolled');
        }
        else {
            header.classList.add('scrolled');
        }
    });
    }
  });

